<template>
  <div class="max-w-6xl mx-auto">
    <ProtexWrapper
      v-if="isIntegrationEnabled('protex')"
      :product-line-slug="data.productLineSlug"
      @has-application=";(renderProtex = $event), $event && $uiEvents.$emit('BuilderButtonViewed', data)"
    />
    <Gallery :gallery="gallery" :show-thumbs="showThumbs">
      <template #protex>
        <!-- Slot won't exist if !renderProtex -->
        <ProtexIframe :base-url="`https://realtruck.oneprotex.com/preview/?focus=${data.productLineSlug}`" fit-div />
      </template>

      <template #thumbProtex="{ activateThumb, activeThumb, index }">
        <!-- Slot won't exist if  !renderProtex -->
        <button
          type="button"
          aria-label="Show Protex"
          :aria-current="activeThumb === index"
          class="border-2 border-solid w-[140px] rounded"
          :class="[activeThumb === index ? 'border-black' : 'border-gray-light']"
          @click="activateThumb(index), $uiEvents.$emit('BuilderButtonClicked', data)"
        >
          <img src="/images/3dSpin.svg" alt="3d Spin Icon" width="72" height="46" class="w-full h-full p-8" />
        </button>
      </template>

      <template #default="{ activateThumb }">
        <div class="flex flex-col mt-4 lg:flex-row lg:mt-0">
          <template v-if="renderProtex && $device.isMobile">
            <button
              type="button"
              class="flex items-center justify-center font-bold py-2 px-6 mb-2 lg:mr-2 lg:mb-0 border rounded text-inherit w-full"
              @click="activateThumb(protexSlotIndex), $uiEvents.$emit('BuilderButtonClicked', data)"
            >
              <img src="/images/3dSpin.svg" alt="" class="w-6 h-4 mr-2" />
              See it on your {{ fitmentStore.model }}
            </button>
          </template>

          <button
            v-if="hasCustomerPhotos"
            type="button"
            class="flex items-center justify-center font-bold py-2 px-6 border rounded"
            @click="showCustomerPhotos"
          >
            <img src="/images/customPhoto.svg" alt="" class="w-[18px] h-3.5 mr-2" />
            Customer Photos
          </button>
        </div>
      </template>
    </Gallery>
  </div>
</template>

<script setup lang="ts">
const { $uiEvents, $device } = useNuxtApp()
const { $scrollTo } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()
const fitmentStore = useFitmentStore()
const renderProtex = ref(false)

const { data, showThumbs, hasCustomerPhotos } = defineProps<{
  data: ProductLine
  showThumbs?: boolean
  hasCustomerPhotos: boolean
}>()

function showCustomerPhotos() {
  const element = document.getElementById('scrollTarget-photos')
  if (element) $scrollTo(element, 500)
}

const protexSlotIndex = 1
const gallery = computed(() => {
  if (!isIntegrationEnabled('protex') || !renderProtex.value) return data.gallery

  const gallery = [...data.gallery]
  // Add the Protex Slots to the gallery
  gallery.splice(protexSlotIndex, 0, {
    gallerySlot: 'protex',
    thumbSlot: 'thumbProtex',
    filename: '',
    key: 'protex',
    title: 'View in Protex',
  })

  return gallery
})
</script>
